<template>
  <Dialog ref="p">
    <div class="dialog-content">
      <div class="title">当前可提现</div>
      <div class="reward-num"><span>{{reward}}</span><span>元</span></div>
      <div class="desc">每天可提现1次，提现金额为30的倍数</div>
      <div :class="[ reward !== 0 ? 'btn-middle flamingo' : 'btn-middle graydisable']" @click="submit()">确认提现</div>
    </div>
  </Dialog>
</template>
<style lang='scss' scoped>
  .dialog-content {
    width: 295px;
    height: 239px;
    padding: 30px 26px;
    text-align: center;

    .title {
      font-size: 18px;
      color: #3A3A3A;
      margin-bottom: 10px;

      @include semibold();
    }

    .reward-num {
      font-size: 36px;
      color: #F75946;

      span:first-child {
        font-size: 36px;
        color: #F75946;

        @include roboto();
      }

      span:nth-child(2) {
        font-size: 13px;
        color: #F75946;

        @include semibold();
      }
    }

    .desc {
      font-size: 13px;
      color: #3A3A3A;
      margin-bottom: 30px;

      @include regular();
    }

    .btn-middle {
      margin: 0 auto;
    }
  }
</style>
<script>
import Dialog from 'components/Dialog'
import { mapActions } from 'vuex'
import { URI_WECHAT_WITHDRAW } from '@/store/modules/account/type'
export default {
  data () {
    return {
      reward_money: 0
    }
  },
  components: {
    Dialog
  },
  props: {
    balanced: {
      type: Number,
      default: ''
    }
  },
  computed: {
    reward () {
      return Math.floor(this.balanced / 30) * 30
    }
  },
  methods: {
    ...mapActions({
      wechatWithdraw: URI_WECHAT_WITHDRAW
    }),
    show () {
      this.$refs.p.show()
    },
    hide () {
      this.$refs.p.hide()
    },
    async submit () {
      if (this.reward === 0) {
        return false
      }
      this.$refs.p.hide()
      let amount = this.reward
      const res = await this.wechatWithdraw({ amount })
      if (res && res.status === 200) {
        this.$emit('updateBalanced', res.data.payload.balance)
        $bus.$emit('confirm')
      }
    }
  }
}
</script>
